import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import { ReportFragment, REPORT_FRAGMENT } from "../../fragments";
import { SignReportMutationVariables } from "../../types";

export const SIGN_REPORT = gql`
  mutation updateReport($input: SignReportInput!) {
    signReport(input: $input) {
      report {
        ...ReportFragment
      }
    }
  }
  ${REPORT_FRAGMENT}
`;

export type ReportData = { updateReport: { report: ReportFragment } };

export default (
  options?: MutationHookOptions<ReportData, SignReportMutationVariables>
) => {
  return useMutation<ReportData, SignReportMutationVariables>(
    SIGN_REPORT,
    options
  );
};
